


































import Vue from "vue";
import _raids from "../../services/endpoints/raids";
import NameComp from "../menu/NameComp.vue";
import { Spieler } from "models/Spieler";

export default Vue.extend({
	name: "SpielerEinladenComp",
	components: { NameComp },
	props: ["raid"],
	data: () => ({
		disabled: false,
		invited: [] as number[],
		invitablePlayers: [] as Spieler[],
		searchInput: "",
	}),
	methods: {
		customFilter: function(item: Spieler, queryText: string): boolean {
			const name = item.name.toLowerCase();
			const accname = item.accname.toLowerCase();
			const searchText = queryText.toLowerCase();

			return name.indexOf(searchText) > -1 || accname.indexOf(searchText) > -1;
		},
	},
	watch: {
		invited: async function(newValue: number[], oldValue: number[]): Promise<void> {
			this.searchInput = "";
			if (oldValue === null) return;
			const invitedPlayer = newValue.find(player => !oldValue.includes(player));
			const deletedPlayer = oldValue.find(player => !newValue.includes(player));
			if (invitedPlayer) {
				await _raids.invitePlayer(this.raid.id, invitedPlayer);
			} else if (deletedPlayer) {
				await _raids.deleteInviteAsLead(this.raid.id, deletedPlayer);
			}
		},
	},
	created: async function(): Promise<void> {
		this.invited = await _raids.pendingInvitesForRaid(this.raid.id);
		this.invitablePlayers = await _raids.invitablePlayers(this.raid.id);
	},
});
